
export const sFechaPublicacion = '2026-09-22T23:55:25.4779330-06:00';
export const sVersion = 'vf1.1.609222355';
            